import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'Common',
			component: () => import('../views/common.vue'),
			redirect: '/index',
			children: [{
				path: '/index',
				name: 'Index',
				meta: {
					title: 'AI测评-点击作答'
				},
				component: () => import('../views/answerview/index.vue')
			},{
				path: '/refresh',
				name: 'refresh',
				meta: {
					title: '更新'
				},
				component: () => import('../views/refresh/refresh.vue')
			}, {
				path: '/answer',
				name: 'Answer',
				meta: {
					title: '去答题'
				},
				component: () => import('../views/answerview/answer.vue')
			}, {
				path: '/completed',
				name: 'Completed',
				meta: {
					title: '答题完成'
				},
				component: () => import('../views/answerview/completed.vue')
			}]
		}, {
			path: '/record',
			name: 'Record',
			meta: {
				title: 'AI测评-测评记录'
			},
			component: () => import('../views/answerview/record.vue')
		}, {
			path: '/evaluationReport',
			name: 'evaluationReport',
			meta: {
				title: '考试报告'
			},
			component: () => import('../views/evaluationReport/evaluationReport.vue')
		}, {
			path: '/comrefresh',
			name: 'Comrefresh',
			meta: {
				title: '更新'
			},
			component: () => import('../views/refresh/comrefresh.vue')
		},
	]
})


export default router